import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=1560d3a8&scoped=true&"
import script from "./BasicSetting.vue?vue&type=script&lang=js&"
export * from "./BasicSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasicSetting.vue?vue&type=style&index=0&id=1560d3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560d3a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1560d3a8')) {
      api.createRecord('1560d3a8', component.options)
    } else {
      api.reload('1560d3a8', component.options)
    }
    module.hot.accept("./BasicSetting.vue?vue&type=template&id=1560d3a8&scoped=true&", function () {
      api.rerender('1560d3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/BasicSetting.vue"
export default component.exports